import { useState } from 'react';
import MainLayout from '../../../components/layout/MainLayout';
import SearchFilters from './components/SearchFilters';
import RecordTable from './components/RecordTable';
import { sendRecords as mockRecords } from './mockData';
import type { SendRecord } from './types';

export default function NotificationRecords() {
  const [records] = useState<SendRecord[]>(mockRecords);
  const [filteredRecords, setFilteredRecords] = useState<SendRecord[]>(mockRecords);

  const handleSearch = (filters: any) => {
    let filtered = [...records];

    if (filters.keyword) {
      filtered = filtered.filter(r =>
        r.phone.includes(filters.keyword) ||
        r.email.includes(filters.keyword) ||
        r.userName.includes(filters.keyword)
      );
    }

    if (filters.notificationItem) {
      filtered = filtered.filter(r => r.notificationItem === filters.notificationItem);
    }

    if (filters.method) {
      filtered = filtered.filter(r => r.method === filters.method);
    }

    if (filters.status) {
      filtered = filtered.filter(r => r.status === filters.status);
    }

    if (filters.sendTimeStart) {
      filtered = filtered.filter(r => r.sendTime >= filters.sendTimeStart.replace('T', ' ') + ':00');
    }

    if (filters.sendTimeEnd) {
      filtered = filtered.filter(r => r.sendTime <= filters.sendTimeEnd.replace('T', ' ') + ':00');
    }

    setFilteredRecords(filtered);
  };

  return (
    <MainLayout>
      <div className="space-y-5">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">发送记录</h1>
          <p className="text-sm text-gray-500 mt-1">查看所有通知的发送记录和状态</p>
        </div>

        <SearchFilters onSearch={handleSearch} />

        <RecordTable records={filteredRecords} />
      </div>
    </MainLayout>
  );
}
